export const getIdFromPathId = (pathId) => {
  const isPathIdString = typeof pathId === "string";
  if (!isPathIdString) return pathId;
  const ids = pathId.split("&");
  if (ids.length < 2) return pathId;
  return `${ids[0]}&${ids[ids.length - 1]}`;
};

export const getShortPath = (path) => {
  const isPathString = typeof path === "string";
  if (!isPathString) return path;
  const paths = path.split(" > ");
  if (paths.length < 2) return path;
  return `${paths[0]} > ${paths[paths.length - 1]}`;
};

export const getLastId = (pathId) => {
  const isPathIdString = typeof pathId === "string";
  if (!isPathIdString) return pathId;
  const ids = pathId.split("&");
  if (ids.length === 0) return pathId[0];
  return ids[ids.length - 1];
};
